import { captureException } from "@sentry/react";
import { useConnection } from "@solana/wallet-adapter-react";
import type { StakingPosition } from "@stepfinance/staking";
import { useEffect, useMemo, useState } from "react";

import { useMarkets } from "../../contexts/market";
import { useRefreshContext } from "../../contexts/refresh";
import { HedgeProgram } from "../../utils/hedge";
import { fetchHedgeStabilityPoolPosition, fetchHedgeStakingPosition } from "../../utils/hedge/staking";
import { useConnectedWallet } from "../wallet";

const handleHedgeStakingError = (e) => {
  console.error("Hedge Staking Error:", e);
  captureException(e);
};

export const useHedgeStaking = () => {
  const { connection } = useConnection();
  const wallet = useConnectedWallet();
  const { refreshID } = useRefreshContext();
  const { marketsInitialised, priceInUSD } = useMarkets();
  const [stakingPositions, setStakingPositions] = useState<StakingPosition[]>([]);

  const hedgeProgram = useMemo(() => wallet && HedgeProgram(connection, wallet), [connection, wallet]);

  useEffect(() => {
    if (hedgeProgram && wallet && marketsInitialised) {
      const stakingPositionsList: StakingPosition[] = [];

      const mergePositionToState = (position: StakingPosition | undefined) => {
        if (position) {
          stakingPositionsList.push(position);
          setStakingPositions([...stakingPositionsList]);
        }
      };

      void fetchHedgeStakingPosition({ hedgeProgram, wallet, priceInUSD })
        .then(mergePositionToState)
        .catch(handleHedgeStakingError);

      void fetchHedgeStabilityPoolPosition({ hedgeProgram, wallet, priceInUSD })
        .then(mergePositionToState)
        .catch(handleHedgeStakingError);
    } else {
      setStakingPositions([]);
    }
  }, [hedgeProgram, marketsInitialised, priceInUSD, wallet, refreshID]);
  return stakingPositions;
};
